import gql from 'graphql-tag';

export const supplierDataDetails = gql`
query getSupplier($id: uuid!){
    dental_suppliers_by_pk(id:$id){
    id
    second_hand
    sell_products
    stripe_customer_id
    directories {
      directory_category_id
    }
    present_subscription_id
    user_subscriptions{
        id
        payment_status
      }

  }
}
`;

export const updateSupplierStripeId = gql`
mutation updateSupplierStripeId($id: uuid!, $stripe_customer_id: String, $present_subscription_id: uuid!) {
  update_dental_suppliers_by_pk(
    pk_columns: { id: $id }
    _set: { stripe_customer_id: $stripe_customer_id,
            payment_completed: true,
            present_subscription_id: $present_subscription_id }
  ) {
    id
    stripe_customer_id
  }
}
`;

export const practiceDataDetails = gql`
query getPractice($id: uuid!){
    dental_practices_by_pk(id:$id){
        id
        second_hand
        sell_products
        present_subscription_id
        stripe_customer_id
        directories {
          directory_category_id
        }
        user_subscriptions{
            id
            payment_status
          }

  }
}
`;

export const updatePracticeStripeId = gql`
mutation updatePracticeStripeId($id: uuid!, $stripe_customer_id: String, $present_subscription_id: uuid!) {
  update_dental_practices_by_pk(
    pk_columns: { id: $id }
    _set: { stripe_customer_id: $stripe_customer_id,
            payment_completed: true,
            present_subscription_id: $present_subscription_id }
  ) {
    id
    stripe_customer_id
  }
}
`;


export const professionalDataDetails = gql`
query getProfessional($id: uuid!){
    dental_professionals_by_pk(id:$id){
        id
        second_hand
        present_subscription_id
        stripe_customer_id
        directories {
          directory_category_id
        }
        user_subscriptions{
            id
            payment_status
          }
  }
}
`;

export const updateProfessionalStripeId = gql`
mutation updateProfessionalStripeId($id: uuid!, $stripe_customer_id: String, $present_subscription_id: uuid!) {
  update_dental_professionals_by_pk(
    pk_columns: { id: $id }
    _set: { stripe_customer_id: $stripe_customer_id,
            payment_completed: true,
            present_subscription_id: $present_subscription_id }
  ) {
    id
    stripe_customer_id
  }
}
`;

export const supplierFilled = gql`
query getSupplier($id: uuid!){
    dental_suppliers_by_pk(id:$id){
    id
    logo
    name
    address
    business_name
    abn_number
    business_email
    business_phone
    fax_number
    alt_email
    alt_phone
    profession_type
    tga_number
    second_hand
    sell_products
    first_name
    middle_name
    last_name
    secondary_contact
    directories {
      directory_category_id
    }
    user_subscriptions{
      id
      payment_status
    }

  }
}
`;




export const practiceFilled = gql`
query getPractice($id: uuid!){
    dental_practices_by_pk(id:$id){
    id
    logo
    name
    address
    business_name
    abn_number
    business_email
    business_phone
    fax_number
    alt_email
    alt_phone
    profession_type
    tga_number
    second_hand
    sell_products
    first_name
    middle_name
    last_name
    secondary_contact
    directories {
      directory_category_id
    }
    user_subscriptions{
      id
      payment_status
    }

  }
}
`;


export const professionalFilled = gql`
query getProfessional($id: uuid!){
    dental_professionals_by_pk(id:$id){
        id
        gender
        profile_image
        first_name
        middle_name
        last_name
        date_of_birth
        email
        phone
        pro_details_aphra_registration_number
        address
        date_of_birth
        salutation
        alt_email
        alt_phone
        profession_type
        driving_licence
        second_hand
        directory_category_id
        directories {
          directory_category_id
        }
        user_subscriptions{
          id
          payment_status
        }
        
      
  }
}
`;

export const getDirectoryDetail = gql`
query getDirectory($id: uuid!) {
  directories(
    where: {
      _or: [
        { dental_practice_id: { _eq: $id } },
        { dental_professional_id: { _eq: $id } },
        { dental_supplier_id: { _eq: $id } }
      ]
    }
  ) {
    directory_category_id
    id
  }
}
`;